<template>
  <div>
    <order-search company-title="Alco" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import OrderSearchVue from "@/components/alco/OrderSearch.vue";

export default defineComponent({
  components: {
    "order-search": OrderSearchVue,
  }
});
</script>
